import { useState } from "react";

import {
  buildReductionsPayload,
  buildReductionsValues,
  isReductionsDirty,
  normalizeNullableEmailInput,
} from "../helper/caseForms";
import { toDateInputValue } from "../helper/date";

import useSettlementCaseForm from "./useSettlementCaseForm";

export default function useReductionsSection({ caseDetail }) {
  const {
    formValues,
    setFormValues,
    isDirty,
    isEditing,
    setIsEditing,
    isSaving,
    canEditCaseSettlement,
    handleCancel: handleBaseCancel,
    handleSave: handleBaseSave,
  } = useSettlementCaseForm({
    caseDetail,
    buildValues: buildReductionsValues,
    buildPayload: buildReductionsPayload,
    isDirtyCheck: isReductionsDirty,
  });
  const [isEmailEditing, setIsEmailEditing] = useState(false);

  const handleFieldChange = (fieldName, value) => {
    if (!canEditCaseSettlement) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [fieldName]:
        fieldName === "reductionReceivedFrom"
          ? normalizeNullableEmailInput(value)
          : toDateInputValue(value),
    }));
  };

  const handleBeginEdit = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setIsEditing(true);
  };

  const handleBeginEmailEdit = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setIsEditing(true);
    setIsEmailEditing(true);
  };

  const handleClearEmail = () => {
    if (!canEditCaseSettlement) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      reductionReceivedFrom: "",
    }));
  };

  const handleCancel = () => {
    handleBaseCancel();
    setIsEmailEditing(false);
  };

  const handleSave = async () => {
    await handleBaseSave(() => {
      setIsEmailEditing(false);
    });
  };

  return {
    formValues,
    isDirty,
    isEditing,
    isEmailEditing,
    isSaving,
    canEditCaseSettlement,
    handleFieldChange,
    handleBeginEdit,
    handleBeginEmailEdit,
    handleClearEmail,
    handleCancel,
    handleSave,
  };
}
